/**
 * Welcome to Cloudflare Workers! This is your first worker.
 *
 * - Run `npx wrangler dev src/index.js` in your terminal to start a development server
 * - Open a browser tab at http://localhost:8787/ to see your worker in action
 * - Run `npx wrangler publish src/index.js --name my-worker` to publish your worker
 *
 * Learn more at https://developers.cloudflare.com/workers/
 */

export function apply_drawfactor_to_poisson(
  env,
  { goalexp_home, goalexp_away, drawfactor, goalaverage }
) {
  let verteilung = [];
  let vertexp1 = [];
  let vertexp2 = [];
  let vertsumrow = [];
  let vertsumcol = [];

  let $forexp = goalexp_home;
  let $agaexp = goalexp_away;
  let $drawrdfc = drawfactor;
  let $Torschnitt = goalaverage;

  let $draw00;

  if ($agaexp > $forexp)
    $draw00 =
      1 +
      (1 / $drawrdfc - 1) * ($forexp / $agaexp) -
      (1 / $drawrdfc - 1) *
        ((($forexp / $agaexp) * Math.abs($Torschnitt - $forexp - $agaexp)) /
          $Torschnitt);
  else
    $draw00 =
      1 +
      (1 / $drawrdfc - 1) * ($agaexp / $forexp) -
      (1 / $drawrdfc - 1) *
        ((($agaexp / $forexp) * Math.abs($Torschnitt - $forexp - $agaexp)) /
          $Torschnitt);

  for (let i = 0; i <= 20; i++) {
    verteilung[i] = [];
    vertsumrow[i] = 0;
    vertexp1[i] = 0;
    vertexp2[i] = 0;
    vertsumcol[i] = 0;
    for (let j = 0; j <= 20; j++) verteilung[i][j] = 0;
  }

  for (let i = 0; i <= 20; i++) {
    vertexp1[i] = poisson(i, $forexp);
    vertsumrow[0] = vertsumrow[0] + vertexp1[i];
    vertexp2[i] = poisson(i, $agaexp);
    vertsumcol[0] = vertsumcol[0] + vertexp2[i];
  }

  vertexp1[1] = vertexp1[1] + 1 - vertsumrow[0];
  vertexp2[1] = vertexp2[1] + 1 - vertsumcol[0];

  for (let i = 0; i <= 20; i++) {
    for (let j = 0; j <= 20; j++) verteilung[i][j] = vertexp1[i] * vertexp2[j];
  }
  vertsumrow[0] = 0;
  vertsumcol[0] = 0;

  for (let i = 0; i <= 2; i++)
    for (let j = 0; j <= 2; j++) {
      vertsumrow[i] = vertsumrow[i] + verteilung[i][j];
      vertsumcol[j] = vertsumcol[j] + verteilung[i][j];
    }
  //  let probsum = 0
  //  for(let i=0; i<=20;i++)
  // 	 for(let j=0;j<=20;j++)
  // 		 probsum+=verteilung[i][j]

  //  let totalgoalexp = 0
  //  for(let i=0; i<=20;i++)
  // 	 for(let j=0;j<=20;j++)
  // 		 totalgoalexp+=verteilung[i][j]*(i+j)

  verteilung[0][0] = verteilung[0][0] * $draw00;
  verteilung[1][1] = verteilung[1][1] * $draw00;
  verteilung[2][2] = verteilung[2][2] * $draw00;

  let $temp0 =
    verteilung[0][0] / $draw00 +
    verteilung[0][1] +
    verteilung[0][2] -
    verteilung[0][0] +
    verteilung[1][0] +
    verteilung[1][1] / $draw00 +
    verteilung[1][2] -
    verteilung[1][1];
  let $temp1 = verteilung[1][0] + verteilung[2][0] + verteilung[2][1];
  let $temp2 =
    verteilung[2][0] +
    verteilung[2][1] +
    verteilung[2][2] / $draw00 -
    verteilung[2][2];
  let $temp3 = verteilung[0][1] + verteilung[0][2] + verteilung[1][2];
  let $temp4 =
    verteilung[0][1] +
    verteilung[0][2] +
    verteilung[1][2] +
    verteilung[1][0] +
    verteilung[2][0] +
    verteilung[2][1];
  verteilung[1][0] = ($temp0 * $temp1 - $temp2 * $temp3) / $temp4;
  verteilung[1][2] = vertsumrow[1] - verteilung[1][0] - verteilung[1][1];
  verteilung[2][0] = vertsumcol[0] - verteilung[0][0] - verteilung[1][0];
  verteilung[0][2] = vertsumcol[2] - verteilung[2][2] - verteilung[1][2];
  verteilung[2][1] = vertsumrow[2] - verteilung[2][2] - verteilung[2][0];
  verteilung[0][1] = vertsumrow[0] - verteilung[0][0] - verteilung[0][2];

  // probsum = 0
  //  for(let i=0; i<=20;i++)
  // 	 for(let j=0;j<=20;j++)
  // 		 probsum+=verteilung[i][j]

  //  totalgoalexp = 0
  //  for(let i=0; i<=20;i++)
  // 	 for(let j=0;j<=20;j++)
  // 		 totalgoalexp+=verteilung[i][j]*(i+j)

  let homewins = 0;
  let draws = 0;
  let awaywins = 0;
  for (let i = 0; i <= 20; i++)
    for (let j = 0; j <= 20; j++) {
      if (i > j) homewins += verteilung[i][j];
      if (i == j) draws += verteilung[i][j];
      if (i < j) awaywins += verteilung[i][j];
    }


  //  totalgoalexp = 0
  //  for(let i=0; i<=20;i++)
  // 	 for(let j=0;j<=20;j++)
  // 		 totalgoalexp+=verteilung[i][j]*(i+j)

  return verteilung;
}

function poisson(x, mittelwert) {
  const a = mittelwert ** x;
  const b = fact(x);
  const c = Math.E ** -mittelwert;
  return (a / b) * c;
}

function fact(x) {
  if (x == 0) {
    return 1;
  }
  return x * fact(x - 1);
}
